import cn from 'classnames';
import { FC, ReactNode } from 'react';

import { Tabs } from '@/shared/ui';

import styles from './DocumentTabs.module.scss';

export type DocumentTab = {
  key: string;
  label: string;
  included: boolean;
  mark?: 'ready' | 'pending';
};

type Props = {
  tabs: DocumentTab[];
  activeKey: string;
  disabled: boolean;
  children: ReactNode;
  className?: string;
  onChange: (key: string) => void;
};

export const DocumentTabs: FC<Props> = ({
  tabs,
  activeKey,
  disabled,
  children,
  className,
  onChange,
}) => {
  const showTabs = tabs.length > 1;

  return (
    <Tabs.Root
      className={cn(styles.root, className)}
      value={activeKey}
      onValueChange={onChange}
    >
      {showTabs && (
        <div className={styles.bar}>
          <Tabs.List className={styles.list} size="small">
            {tabs.map((tab) => (
              <Tabs.Trigger
                key={tab.key}
                value={tab.key}
                size="small"
                disabled={disabled}
                className={cn(
                  'p3b',
                  styles.tab,
                  !tab.included && styles.optional,
                )}
              >
                {tab.included ? tab.label : `+ ${tab.label}`}
                {tab.mark && (
                  <span className={cn(styles.mark, styles[tab.mark])} />
                )}
              </Tabs.Trigger>
            ))}
          </Tabs.List>
        </div>
      )}
      <Tabs.Content value={activeKey} className={styles.content}>
        {children}
      </Tabs.Content>
    </Tabs.Root>
  );
};
